module.exports = __webpack_public_path__ + "media/images/default/pages/about/6-c2d1542495746b3f91a485d7bfd63424.jpg";